import { responseHandler } from "@msuite/ui/utils";
import type { GetCheckInRequirementsQuerySchema } from "@msuite/utils/schemas";
import type { CheckInRequirements } from "@msuite/utils/types";
import { client } from "@/hono";

/**
 * Reads what the signed-in user still has to confirm before checking in on a worksite: the
 * acknowledgement texts the worksite requires, and the risk-assessment documents pending for
 * them — a document acknowledged within its interval is not in the answer.
 *
 * Only a check-in asks; a check-out ends the live attendance and confirms nothing.
 *
 * @param query - The worksite to check in on, and its project when it is a project site.
 * @returns The requirements for that worksite, as the check-in steps consume them.
 */
export async function getCheckInRequirements(
	query: GetCheckInRequirementsQuerySchema,
): Promise<CheckInRequirements> {
	const response = await client.users.attendances.requirements.$get({ query });
	const data = await responseHandler(response);
	return data.requirements;
}
